import * as actionTypes from "../actions";
const initialState = {
  data: [],
  loading: false,
  vehicleGrid: []
};
const vehicles = (state = initialState, action) => {
  let index = -1;

  switch (action.type) {
    case actionTypes.STORE_VEHICLE:
      return {
        data: action.data,
        loading: false
      };
    case actionTypes.STORE_VEHICLE_GRID:
      return {
        vehicleGrid: action.data
      };
    case actionTypes.ADD_VEHICLE:
      if (action.data) {
        state.data.vehicles.push(action.data);
      }
      return { ...state, data: state.data, loading: false };

    case actionTypes.UPDATE_VEHICLE: {
      index = state.data.vehicles.findIndex(e => e[0] === action.data[0]);

      if (index === -1) {
        state.data.vehicles.push(action.data);
      } else {
        state.data.vehicles[index] = action.data;
      }
      return {
        ...state,
        data: state.data,
        loading: false
      };
    }
    case actionTypes.REQUEST_VEHICLE:
      return {
        ...state,
        loading: true
      };
    // case actionTypes.GET_VEHICLE:
    //   return Object.assign({}, state);
    default:
      return state;
  }
};
export default vehicles;



// WEBPACK FOOTER //
// ./src/redux/reducers/vehicles.js